import React, { memo } from 'react'

// Skeleton loading
import Skeleton from 'react-loading-skeleton';

function ProductList__loadingSkeleton() {
    return (
        <div className="col-md-4 col-lg-3 mb-4">
            <Skeleton count={1} height={250} width={"100%"} />

            <Skeleton
                count={1}
                height={30}
                width={250}
                className="d-block mx-auto"
                style={{ marginTop: 15 }}
            />
        </div>
    )
}

export default memo(ProductList__loadingSkeleton)